import { CommandParser } from '../client/parser';
import { SimpleStringReply, Command } from '../RESP/types';

export default {
  IS_READ_ONLY: true,
  parseCommand(parser: CommandParser) {
    parser.push('READWRITE');
  },
  transformReply: undefined as unknown as () => SimpleStringReply
} as const satisfies Command;
